import React from "react";
import { Modal, Button } from "antd";
import "./release-notes-modal.css";
import ReleaseNotesContent from "./ReleaseNotesContent";

const ReleaseNotesModal = ({ isOpen, onClose, onNext, loading, releaseNotesData }) => {
  return (
    <Modal
      title=""
      open={isOpen}
      onCancel={onClose}
      footer={null}
      className="release-notes-modal"
      width={850}
      style={{ top: 100 }}
      closable={false}
      maskClosable={false}
    >
      <div className="release-notes-container">
        <div className="release-notes-header">
          {/* <h3>Release Notes (βv2.9)</h3> */}
        </div>
        
        <div className="release-notes-content-box">
          <ReleaseNotesContent releaseNotesData={releaseNotesData} />
        </div>
        
        <div className="release-notes-footer">
          <Button 
            type="primary" 
            onClick={onNext}
            className="release-notes-next-button"
            loading={loading}
            disabled={loading}
          >
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReleaseNotesModal; 